// mailService.js
import { API_HEADERS } from "../pages/config";

export async function sendContactMail(subject, comments) {
  const payload = { subject, comments };

  try {
    const res = await fetch("https://api.virtualkalvi.com/sendContactMail", {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      return { success: false, message: "Failed to send message" };
    }

    return { success: true, message: "Message sent successfully!" };
  } catch (err) {
    console.error("Mail Error:", err);
    return { success: false, message: "Error sending message" };
  }
}
